<div class="alert-dialog-outer">
	<h2 mat-dialog-title>{{ title }}</h2>
	<mat-dialog-content>
		<p tabindex="1" aria-live="polite">{{ content }}</p>
	</mat-dialog-content>
	<mat-dialog-actions align="start">
		<button class="btn btn-primary" mat-button mat-dialog-close>Ok</button>
	</mat-dialog-actions>
</div>
